import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-prantwise-all-total-business-report',
  // standalone: true,
  // imports: [],
  templateUrl: './prantwise-all-total-business-report.component.html',
  styleUrl: './prantwise-all-total-business-report.component.scss'
})
export class PrantwiseAllTotalBusinessReportComponent implements OnInit  {


   offrepwiseData;
     today = new Date();
     startDate = '';
     endDate = '';
     isLoading: boolean = false;
     subTypesName = [
       { name: 'वार्षिक', isVisible: false },
       { name: 'त्रैवार्षिक', isVisible: false },
       { name: 'पंचवार्षिक', isVisible: false },
     ];
     totalth = 0;
     finalData = [];
     off_rep_name;
     appliedFilters: any = {};
   
     constructor(
       public dialogref: MatDialogRef<PrantwiseAllTotalBusinessReportComponent>,
       @Inject(MAT_DIALOG_DATA) public data: any, public service: DigisubservicesService,
     ) {}
   
     ngOnInit(): void {
       this.isLoading = true;
       this.offrepwiseData = this.data['offrepwisedata'];
       this.off_rep_name = this.data['off_rep_name'];
       this.startDate = this.data['startDate'];
       this.endDate = this.data['endDate'];
       // console.log(this.offrepwiseData);
       
      this.appliedFilters = this.data['appliedFilters'] || {};
   
      console.log("Applied Filters:", this.appliedFilters);
   
       let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);
   
       for (let i = 0; i < Object.keys(data).length; i++) {
         let flag = false;
         for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
           if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
             this.subTypesName[j]['isVisible'] = true;
             flag = true;
             break;
           }
         }
         if (!flag) {
           // if (
           //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
           //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
           //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
           //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
           //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
           // ) {
           this.subTypesName.push({
             name: data[i]['subscription_type'],
             isVisible: true,
           });
           // }
         }
       }
   
       // console.log(this.subTypesName);
       // this.totalth = this.subTypesName.length * 4 + 8;
   
        this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 34;
   
       // this.getoffdata();
      //  this.setData();
        // ✅ IMPORTANT: CALL EXPENSE API FIRST
    this.loadExpenseData();
    this.getAllVouchersData();
     }
  
  expenseLedgerData: any[] = [];
  
  getallVouchersData: any[] = [];
  
  loadExpenseData() {
  
    const request = {
      exp_id: 35,
      sub_exp_id: "312",
      startdate: this.startDate,
      enddate: this.endDate
    };
  
    this.service.getExpenseLedgerReportData(request).subscribe({
      next: (res: any) => {
        this.expenseLedgerData = res || [];
        console.log('EXPENSE Ledger Data:', res);
        this.setData();
      },
      error: () => {
        this.expenseLedgerData = [];
        this.setData();
      }
    });
  }
  
  getAllVouchersData() {
  
    const fyStart = this.startDate;
    const fyEnd = this.endDate;
  
    this.service.getvoucherbySub(fyStart, fyEnd).subscribe(
      (res: any) => {
  
        console.log('EXPENSE API RESPONSE:', res);
  
        // ✅ FIX: handle both cases (array OR object)
        this.getallVouchersData = Array.isArray(res)
          ? res
          : (res?.data || []);
  
        console.log('FINAL VOUCHER DATA:', this.getallVouchersData);
  
        this.setData();
      },
      (error: any) => {
        console.error('EXPENSE API ERROR:', error);
  
        this.getallVouchersData = [];
        this.setData();
      }
    );
  }
  
//Existing All Correct Code
// setData() {

//   if (!this.offrepwiseData) return;

//   const NET_TYPES = [
//     'वार्षिक',
//     'त्रैवार्षिक',
//     'पंचवार्षिक',
//     'ऑनलाईन अंक सहामाही',
//     'ऑनलाईन अंक वार्षिक'
//   ];

//   const EXCLUDE_YOJANA = [
//     ...NET_TYPES,
//     'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
//   ];

//   const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

//   const normalize = (val: any) =>
//     (val || '')
//       .toString()
//       .trim()
//       .replace(/\s+/g, ' ')
//       .replace(/[^\w\u0900-\u097F ]/g, '')
//       .toLowerCase();

//   const normalizeText = (val: any) =>
//     (val || '').toString().trim().toLowerCase();

//   // ================= 🔥 FIXED DISTRICT → PRANT =================
//   const districtPrantMap = new Map<string, string>();

//   this.offrepwiseData.forEach((row: any) => {

//     let dist = (row.rep_district || 'Unknown').trim();
//     let prant = (row.prant_name || 'Unknown').trim();

//     // ✅ FORCE FIX: Mumbai always Konkan
//     if (
//       normalizeText(dist) === 'मुंबई' ||
//       normalizeText(dist) === 'mumbai'
//     ) {
//       prant = 'कोकण प्रांत';
//     }

//     if (!districtPrantMap.has(dist)) {
//       districtPrantMap.set(dist, prant);
//     }

//     row.prant_name = districtPrantMap.get(dist);
//   });

//   // ================= DONATION =================
//   const allVouchers = (
//     Array.isArray(this.expenseLedgerData)
//       ? this.expenseLedgerData
//       : []
//   ).reduce((acc: any[], exp: any) => {

//     const expName = normalize(exp.exp_name);
//     const subExpName = normalize(exp.sub_exp_name);

//     const isDonation =
//       expName.includes('देणगी') ||
//       subExpName.includes('वर्गणी विभाग - देणगी');

//     if (isDonation && Array.isArray(exp.vouchers)) {
//       acc.push(...exp.vouchers);
//     }

//     return acc;

//   }, []);

//   const donationMap: any = {};

//   const start = new Date(this.startDate);
//   const end = new Date(this.endDate);

//   allVouchers.forEach((v: any) => {

//     const rep = normalize(v.rep_name);

//     if (!rep) return;

//     const vDate = new Date(v.voucher_date);

//     if (isNaN(vDate.getTime())) return;
//     if (vDate < start || vDate > end) return;

//     if (!donationMap[rep]) {
//       donationMap[rep] = {
//         count: 0,
//         amount: 0
//       };
//     }

//     donationMap[rep].count += 1;
//     donationMap[rep].amount += Number(v.exp_amt) || 0;
//   });

//   // ================= PENDING =================
//   const pendingMap: any = {};

//   (this.getallVouchersData || []).forEach((v: any) => {

//     const rep = normalize(v.rep_name);

//     if (!rep) return;

//     if (!pendingMap[rep]) {
//       pendingMap[rep] = 0;
//     }

//     pendingMap[rep] += Number(v.remaining_amt) || 0;
//   });

//   // ================= FINAL TOTAL =================
//   const finalTotal: any = {

//     name: 'एकूण',

//     sub: 0,

//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0,

//     net_नवीन: 0,
//     net_नूतनीकरण: 0,
//     net_नूतनीकरणबाकी: 0,
//     net_एकूण: 0,
//     net_amount: 0,

//     yojana_नवीन: 0,
//     yojana_नूतनीकरण: 0,
//     yojana_नूतनीकरणबाकी: 0,
//     yojana_एकूण: 0,
//     yojana_amount: 0,

//     ठेवीदार: 0,

//     'देणगी': 0,
//     'देणगी_amount': 0,

//     pending_amount: 0
//   };

//   this.subTypesName.forEach((b: any) => {

//     if (!b.isVisible) return;

//     const key = this.getKey(b.name);

//     finalTotal[key + '_नवीन'] = 0;
//     finalTotal[key + '_नूतनीकरण'] = 0;
//     finalTotal[key + '_नूतनीकरणबाकी'] = 0;
//     finalTotal[key + '_एकूण'] = 0;
//   });

//   this.finalData = [];

//   // ================= PRANT GROUPING =================
//   const PRANT_ORDER = [
//     'कोकण प्रांत',
//     'पश्चिम प्रांत',
//     'देवगिरी प्रांत',
//     'विदर्भ प्रांत'
//   ];

//   const uniquePrants = (
//     this.uniqueData(
//       this.offrepwiseData,
//       (a: any) => a.prant_name
//     ) as any[]
//   ).sort((a: any, b: any) => {

//     const indexA = PRANT_ORDER.indexOf(
//       (a.prant_name || '').trim()
//     );

//     const indexB = PRANT_ORDER.indexOf(
//       (b.prant_name || '').trim()
//     );

//     if (indexA !== -1 && indexB !== -1) {
//       return indexA - indexB;
//     }

//     if (indexA !== -1) return -1;
//     if (indexB !== -1) return 1;

//     return (a.prant_name || '').localeCompare(
//       b.prant_name || ''
//     );
//   });

//   for (const prant of uniquePrants) {

//     const prantData = this.offrepwiseData.filter(
//       (a: any) => a.prant_name === prant.prant_name
//     );

//     const repDataGroup: any[] = [];

//     const uniqueDistricts = this.uniqueData(
//       prantData,
//       (a: any) => a.rep_district
//     ) as any[];

//     for (const dist of uniqueDistricts) {

//       const districtData = prantData.filter(
//         (a: any) => a.rep_district === dist.rep_district
//       );

//       const uniqueReps = this.uniqueData(
//         districtData,
//         (a: any) => a.rep_name
//       ) as any[];

//       for (const rep of uniqueReps) {

//         const repRecords = districtData.filter(
//           (a: any) => a.rep_name === rep.rep_name
//         );

//         const repKey = normalize(rep.rep_name);

//         const donation = donationMap[repKey] || {
//           count: 0,
//           amount: 0
//         };

//         const pendingAmt = pendingMap[repKey] || 0;

//         if (!repRecords.length) continue;

//         const subTotal: any = {

//           ...repRecords[0],

//           sub: 0,

//           'एकूण': 0,
//           'नवीन': 0,
//           'नूतनीकरण': 0,
//           'नूतनीकरणबाकी': 0,

//           net_नवीन: 0,
//           net_नूतनीकरण: 0,
//           net_नूतनीकरणबाकी: 0,
//           net_एकूण: 0,
//           net_amount: 0,

//           yojana_नवीन: 0,
//           yojana_नूतनीकरण: 0,
//           yojana_नूतनीकरणबाकी: 0,
//           yojana_एकूण: 0,
//           yojana_amount: 0,

//           ठेवीदार: 0,

//           'देणगी': 0,
//           'देणगी_amount': 0,

//           pending_amount: 0
//         };

//         this.subTypesName.forEach((b: any) => {

//           if (!b.isVisible) return;

//           const key = this.getKey(b.name);

//           subTotal[key + '_नवीन'] = 0;
//           subTotal[key + '_नूतनीकरण'] = 0;
//           subTotal[key + '_नूतनीकरणबाकी'] = 0;
//           subTotal[key + '_एकूण'] = 0;
//         });

//         const today = new Date();

//         today.setMonth(today.getMonth() + 1);

//         for (const record of repRecords) {

//           const subType = record.subscription_type || '';

//           const key = this.getKey(subType);

//           const isFuture =
//             new Date(record.sub_perid_to_date) > today;

//           // ✅ FIX
//           const amt = Number(record.total_amt) || 0;

//           // ================= SUB COUNT =================
//           if (subType !== DEPOSIT_TYPE) {

//             subTotal.sub++;
//             finalTotal.sub++;
//           }

//           // ================= DEPOSIT =================
//           if (subType === DEPOSIT_TYPE && key) {

//             subTotal['ठेवीदार']++;
//             finalTotal['ठेवीदार']++;

//             if (record.rcpt_type === 'New') {

//               subTotal[key + '_नवीन']++;
//               finalTotal[key + '_नवीन']++;

//             } else {

//               subTotal[key + '_नूतनीकरण']++;
//               finalTotal[key + '_नूतनीकरण']++;
//             }

//             // ✅ FIX:
//             // amount always add
//             subTotal[key + '_एकूण'] =
//               (subTotal[key + '_एकूण'] || 0) + amt;

//             finalTotal[key + '_एकूण'] =
//               (finalTotal[key + '_एकूण'] || 0) + amt;
//           }

//           // ================= NET =================
//           if (NET_TYPES.includes(subType)) {

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal.net_नवीन++;
//                 finalTotal.net_नवीन++;

//               } else {

//                 subTotal.net_नूतनीकरण++;
//                 finalTotal.net_नूतनीकरण++;
//               }

//             } else {

//               subTotal.net_नूतनीकरणबाकी++;
//               finalTotal.net_नूतनीकरणबाकी++;
//             }

//             // ✅ FIX:
//             // amount always add
//             subTotal.net_amount =
//               (subTotal.net_amount || 0) + amt;

//             finalTotal.net_amount =
//               (finalTotal.net_amount || 0) + amt;

//             subTotal.net_एकूण++;
//             finalTotal.net_एकूण++;
//           }

//           // ================= YOJANA =================
//           if (!EXCLUDE_YOJANA.includes(subType)) {

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal.yojana_नवीन++;
//                 finalTotal.yojana_नवीन++;

//               } else {

//                 subTotal.yojana_नूतनीकरण++;
//                 finalTotal.yojana_नूतनीकरण++;
//               }

//             } else {

//               subTotal.yojana_नूतनीकरणबाकी++;
//               finalTotal.yojana_नूतनीकरणबाकी++;
//             }

//             // ✅ FIX:
//             // amount always add
//             subTotal.yojana_amount =
//               (subTotal.yojana_amount || 0) + amt;

//             finalTotal.yojana_amount =
//               (finalTotal.yojana_amount || 0) + amt;

//             subTotal.yojana_एकूण++;
//             finalTotal.yojana_एकूण++;
//           }

//           // ================= SUB TYPE =================
//           if (key && subType !== DEPOSIT_TYPE) {

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal[key + '_नवीन']++;
//                 finalTotal[key + '_नवीन']++;

//               } else {

//                 subTotal[key + '_नूतनीकरण']++;
//                 finalTotal[key + '_नूतनीकरण']++;
//               }

//             } else {

//               subTotal[key + '_नूतनीकरणबाकी']++;
//               finalTotal[key + '_नूतनीकरणबाकी']++;
//             }

//             // ✅ FIX:
//             // वार्षिक - 1200 correct
//             subTotal[key + '_एकूण'] =
//               (subTotal[key + '_एकूण'] || 0) + amt;

//             finalTotal[key + '_एकूण'] =
//               (finalTotal[key + '_एकूण'] || 0) + amt;
//           }

//           // ================= MAIN TOTAL =================
//           if (subType !== DEPOSIT_TYPE) {

//             if (isFuture) {

//               if (record.rcpt_type === 'New') {

//                 subTotal['नवीन']++;
//                 finalTotal['नवीन']++;

//               } else {

//                 subTotal['नूतनीकरण']++;
//                 finalTotal['नूतनीकरण']++;
//               }

//             } else {

//               subTotal['नूतनीकरणबाकी']++;
//               finalTotal['नूतनीकरणबाकी']++;
//             }

//             // ✅ FIX:
//             // amount always add
//             subTotal['एकूण'] =
//               (subTotal['एकूण'] || 0) + amt;

//             finalTotal['एकूण'] =
//               (finalTotal['एकूण'] || 0) + amt;
//           }
//         }

//         // ================= DONATION =================
//         subTotal['देणगी'] = donation.count;

//         subTotal['देणगी_amount'] = donation.amount;

//         finalTotal['देणगी'] += donation.count;

//         finalTotal['देणगी_amount'] += donation.amount;

//         // ================= PENDING =================
//         subTotal['pending_amount'] = pendingAmt;

//         finalTotal['pending_amount'] += pendingAmt;

//         // ================= ROW TOTAL =================
//         subTotal['row_total'] =
//           (subTotal['एकूण'] || 0) +
//           (subTotal['net_amount'] || 0) +
//           (subTotal['yojana_amount'] || 0) +
//           (subTotal['देणगी_amount'] || 0);

//         repDataGroup.push(subTotal);
//       }
//     }

//     const prantTotal = repDataGroup.reduce((acc: any, row: any) => {

//       Object.keys(row).forEach(k => {

//         if (typeof row[k] === 'number') {

//           acc[k] = (acc[k] || 0) + row[k];
//         }
//       });

//       return acc;

//     }, {
//       name: prant.prant_name + ' - एकूण',
//       isOfficeRepTotal: true
//     });

//     repDataGroup.push(prantTotal);

//     this.finalData.push(repDataGroup);
//   }

//   finalTotal['row_total'] =
//     (finalTotal['एकूण'] || 0) +
//     (finalTotal['net_amount'] || 0) +
//     (finalTotal['yojana_amount'] || 0) +
//     (finalTotal['देणगी_amount'] || 0);

//   this.finalData.push(finalTotal);

//   this.isLoading = false;
// }

  getRowTotal(row: any): number {
    let total = 0;
  
    // Net amount
    // total += Number(row.net_amount || 0);
  
    // Yojana amount
    // total += Number(row.yojana_amount || 0);
  
    // Main total amount
    total += Number(row['एकूण'] || 0);

        // ✅ ADD THIS (Deposit amount)
  const depositKey = this.getKey('मुदत ठेव (पंचवार्षिक वर्गणीदार)');
  total += Number(row[depositKey + '_एकूण'] || 0);
  
    // Sub types amount
    // this.subTypesName.forEach((sub: any) => {
    //   if (sub.isVisible) {
    //     const key = this.getKey(sub.name);
    //     total += Number(row[key + '_एकूण'] || 0);
    //   }
    // });
  
    // Donation
    total += Number(row['देणगी_amount'] || 0);
  
    // Pending
    total += Number(row['pending_amount'] || 0);
  
    return total;
  }


//   getDistrictGroups(repData: any[]): any[] {

//   if (!Array.isArray(repData)) return [];

//   const map = new Map();

//   for (const row of repData) {

//     if (row.isOfficeRepTotal) continue;

//     const dist = row.rep_district || 'Unknown';

//     if (!map.has(dist)) {
//       map.set(dist, { rows: [], total: null });
//     }

//     map.get(dist).rows.push(row);
//   }

//   map.forEach((value) => {

//     if (!value.rows.length) return;

//     const total: any = {
//       sub: 0,
//       'एकूण': 0,
//       'नवीन': 0,
//       'नूतनीकरण': 0,
//       'नूतनीकरणबाकी': 0,

//       net_नवीन: 0,
//       net_नूतनीकरण: 0,
//       net_एकूण: 0,
//       net_amount: 0,

//       yojana_नवीन: 0,
//       yojana_नूतनीकरण: 0,
//       yojana_एकूण: 0,
//       yojana_amount: 0,

//       ठेवीदार: 0,
//       देणगी: 0,
//       देणगी_amount: 0,
//       pending_amount: 0   // ✅ FIX ADDED
//     };

//     // ✅ dynamic subtype init
//     this.subTypesName.forEach((b: any) => {
//       if (!b.isVisible) return;

//       const key = this.getKey(b.name);

//       total[key + '_नवीन'] = 0;
//       total[key + '_नूतनीकरण'] = 0;
//       total[key + '_नूतनीकरणबाकी'] = 0;
//       total[key + '_एकूण'] = 0;
//     });

//     // ✅ SAFE SUMMATION (NO CHANGE IN LOGIC)
//     value.rows.forEach((r: any) => {
//       Object.keys(r).forEach((k) => {
//         if (typeof r[k] === 'number') {
//           total[k] = (total[k] || 0) + (r[k] || 0);
//         }
//       });
//     });

//     // ✅ row_total calculation (IMPORTANT)
//     total['row_total'] =
//       (total['एकूण'] || 0) +
//       (total['net_amount'] || 0) +
//       (total['yojana_amount'] || 0) +
//       (total['देणगी_amount'] || 0);

//     total['name'] = 'एकूण';
//     total['rep_district'] = value.rows[0]?.rep_district || 'Unknown';

//     value.total = total;
//   });

//   return Array.from(map.values());
// }

getDistrictGroups(repData: any[]): any[] {

  if (!Array.isArray(repData)) return [];

  const map = new Map<string, any>();

  // ================= GROUP BY DISTRICT =================
  for (const row of repData) {

    // skip prant total row
    if (row.isOfficeRepTotal) continue;

    const dist = row.rep_district || 'Unknown';

    if (!map.has(dist)) {
      map.set(dist, { rows: [], total: null });
    }

    map.get(dist).rows.push(row);
  }

  // ================= DISTRICT TOTAL =================
  map.forEach((value) => {

    if (!value.rows || !value.rows.length) return;

    const total: any = {

      sub: 0,
      'एकूण': 0,
      'नवीन': 0,
      'नूतनीकरण': 0,
      'नूतनीकरणबाकी': 0,

      net_नवीन: 0,
      net_नूतनीकरण: 0,
      net_एकूण: 0,
      net_amount: 0,

      yojana_नवीन: 0,
      yojana_नूतनीकरण: 0,
      yojana_एकूण: 0,
      yojana_amount: 0,

      ठेवीदार: 0,
      देणगी: 0,
      देणगी_amount: 0,
      pending_amount: 0
    };

    // ================= DYNAMIC SUB TYPES =================
    this.subTypesName.forEach((b: any) => {

      if (!b.isVisible) return;

      const key = this.getKey(b.name);

      total[key + '_नवीन'] = 0;
      total[key + '_नूतनीकरण'] = 0;
      total[key + '_नूतनीकरणबाकी'] = 0;
      total[key + '_एकूण'] = 0;
    });

    // ================= SAFE SUM =================
    value.rows.forEach((row: any) => {

      Object.keys(row).forEach((k) => {

        if (typeof row[k] === 'number') {
          total[k] = (total[k] || 0) + (row[k] || 0);
        }

      });

    });

    // ================= IMPORTANT: ROW TOTAL =================
    total['row_total'] =
      (total['एकूण'] || 0) +
      (total['net_amount'] || 0) +
      (total['yojana_amount'] || 0) +
      (total['देणगी_amount'] || 0);

    // ================= LABEL =================
    total['name'] = 'एकूण';
    total['rep_district'] = value.rows[0]?.rep_district || 'Unknown';

    value.total = total;
  });

  return Array.from(map.values());
}

// NEW CORRECT CODE
setData() {

  if (!this.offrepwiseData) return;

  const NET_TYPES = [
    'वार्षिक',
    'त्रैवार्षिक',
    'पंचवार्षिक',
    'ऑनलाईन अंक सहामाही',
    'ऑनलाईन अंक वार्षिक'
  ];

  const EXCLUDE_YOJANA = [
    ...NET_TYPES,
    'मुदत ठेव (पंचवार्षिक वर्गणीदार)'
  ];

  const DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

  const normalize = (val: any) =>
    (val || '')
      .toString()
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/[^\w\u0900-\u097F ]/g, '')
      .toLowerCase();

  const normalizeText = (val: any) =>
    (val || '').toString().trim().toLowerCase();

  // =========================================================
  // 🔥 AUTO DISTRICT → PRANT FIX
  // =========================================================

  const districtPrantMap = new Map<string, string>();

  this.offrepwiseData.forEach((row: any) => {

    const dist = (row.rep_district || 'इतर').trim();

    let prant = (row.prant_name || 'इतर').trim();

    // =====================================================
    // 🔥 SPECIAL FIX
    // =====================================================

    if (
      normalizeText(dist) === 'मुंबई' ||
      normalizeText(dist) === 'mumbai'
    ) {
      prant = 'कोकण प्रांत';
    }

    // =====================================================
    // 🔥 IMPORTANT
    // NEVER OVERRIDE VALID PRANT WITH "इतर"
    // =====================================================

    const existingPrant = districtPrantMap.get(dist);

    if (
      !existingPrant ||
      existingPrant === 'इतर'
    ) {

      if (
        prant &&
        prant !== 'इतर' &&
        prant !== '-'
      ) {

        districtPrantMap.set(dist, prant);
      }
    }

    // =====================================================
    // 🔥 FINAL ASSIGN
    // =====================================================

    row.prant_name =
      districtPrantMap.get(dist) ||
      prant ||
      'इतर';
  });

  // =========================================================
  // 🔥 REP MASTER MAP
  // =========================================================

  const repMasterMap: any = {};

  (this.offrepwiseData || []).forEach((r: any) => {

    const repKey = normalize(r.rep_name);

    if (!repKey) return;

    if (
      !repMasterMap[repKey] &&
      r.rep_district &&
      r.rep_district !== 'इतर' &&
      r.rep_district !== '-'
    ) {

      repMasterMap[repKey] = {

        rep_district: r.rep_district || 'इतर',

        rep_taluka: r.rep_taluka || '-',

        prant_name:
          districtPrantMap.get(r.rep_district) ||
          r.prant_name ||
          'इतर',

        office_rep_name: r.office_rep_name || ''
      };
    }
  });

  // =========================================================
  // 🔥 ADD PENDING ONLY RECORDS
  // =========================================================

  (this.getallVouchersData || []).forEach((v: any) => {

    const repName =
      v.rep_name ||
      v.representative_name ||
      v.name ||
      '';

    const repKey = normalize(repName);

    if (!repKey) return;

    // =====================================================
    // 🔥 IF VALID RECORD EXISTS → SKIP
    // =====================================================

    const existingValidRecord = (this.offrepwiseData || []).find(
      (x: any) =>
        normalize(x.rep_name) === repKey &&
        x.rep_district &&
        x.rep_district !== 'इतर' &&
        x.rep_district !== '-'
    );

    if (existingValidRecord) {
      return;
    }

    const master = repMasterMap[repKey] || {};

    const district =
      master.rep_district ||
      v.rep_district ||
      v.district ||
      'इतर';

    const taluka =
      master.rep_taluka ||
      v.rep_taluka ||
      v.taluka ||
      '-';

    // =====================================================
    // 🔥 AUTO PRANT FROM DISTRICT
    // =====================================================

    const prant =
      districtPrantMap.get(district) ||
      master.prant_name ||
      v.prant_name ||
      'इतर';

    const districtExists = (this.offrepwiseData || []).some(
      (x: any) =>
        normalize(x.rep_name) === repKey &&
        normalize(x.rep_district) === normalize(district)
    );

    if (districtExists) {
      return;
    }

    this.offrepwiseData.push({

      rep_name: repName,

      rep_district: district,

      rep_taluka: taluka,

      prant_name: prant,

      office_rep_name:
        master.office_rep_name ||
        v.office_rep_name ||
        '',

      subscription_type: '',

      rcpt_type: '',

      total_amt: 0,

      sub_perid_to_date: new Date(),

      isPendingOnlyRecord: true
    });
  });

  // ================= DONATION =================

  // const allVouchers = (
  //   Array.isArray(this.expenseLedgerData)
  //     ? this.expenseLedgerData
  //     : []
  // ).reduce((acc: any[], exp: any) => {

  //   const expName = normalize(exp.exp_name);
  //   const subExpName = normalize(exp.sub_exp_name);

  //   const isDonation =
  //     expName.includes('देणगी') ||
  //     subExpName.includes('वर्गणी विभाग - देणगी');

  //   if (isDonation && Array.isArray(exp.vouchers)) {
  //     acc.push(...exp.vouchers);
  //   }

  //   return acc;

  // }, []);

  const expenseData = Array.isArray(this.expenseLedgerData)
  ? this.expenseLedgerData
  : (this.expenseLedgerData ? [this.expenseLedgerData] : []);

const allVouchers = expenseData.reduce((acc: any[], exp: any) => {

  const expName = normalize(exp.exp_name);
  const subExpName = normalize(exp.sub_exp_name);

  const isDonation =
    expName.includes('देणगी') ||
    subExpName.includes('वर्गणी विभाग');

  if (isDonation && Array.isArray(exp.vouchers)) {
    acc.push(...exp.vouchers);
  }

  return acc;

}, []);

console.log('expenseLedgerData =', this.expenseLedgerData);
console.log('expenseData =', expenseData);
console.log('allVouchers =', allVouchers);
// console.log('donationMap =', donationMap);

  const donationMap: any = {};

  const start = new Date(this.startDate);
  const end = new Date(this.endDate);

  allVouchers.forEach((v: any) => {

    const rep = normalize(v.rep_name);

    if (!rep) return;

    const vDate = new Date(v.voucher_date);

    if (isNaN(vDate.getTime())) return;
    if (vDate < start || vDate > end) return;

    if (!donationMap[rep]) {

      donationMap[rep] = {
        count: 0,
        amount: 0
      };
    }

    donationMap[rep].count += 1;
    donationMap[rep].amount += Number(v.exp_amt) || 0;
  });

  // ================= PENDING =================

  const pendingMap: any = {};

  (this.getallVouchersData || []).forEach((v: any) => {

    const repName =
      v.rep_name ||
      v.representative_name ||
      v.name ||
      '';

    const rep = normalize(repName);

    if (!rep) return;

    if (!pendingMap[rep]) {
      pendingMap[rep] = 0;
    }

    pendingMap[rep] +=
      Number(v.remaining_amt) ||
      Number(v.pending_amount) ||
      0;
  });

  // ================= FINAL TOTAL =================

  const finalTotal: any = {

    name: 'एकूण',

    sub: 0,

    'एकूण': 0,
    'नवीन': 0,
    'नूतनीकरण': 0,
    'नूतनीकरणबाकी': 0,

    net_नवीन: 0,
    net_नूतनीकरण: 0,
    net_नूतनीकरणबाकी: 0,
    net_एकूण: 0,
    net_amount: 0,

    yojana_नवीन: 0,
    yojana_नूतनीकरण: 0,
    yojana_नूतनीकरणबाकी: 0,
    yojana_एकूण: 0,
    yojana_amount: 0,

    ठेवीदार: 0,

    'देणगी': 0,
    'देणगी_amount': 0,

    pending_amount: 0
  };

  this.subTypesName.forEach((b: any) => {

    if (!b.isVisible) return;

    const key = this.getKey(b.name);

    finalTotal[key + '_नवीन'] = 0;
    finalTotal[key + '_नूतनीकरण'] = 0;
    finalTotal[key + '_नूतनीकरणबाकी'] = 0;
    finalTotal[key + '_एकूण'] = 0;
  });

  this.finalData = [];

  // ================= PRANT GROUPING =================

  const PRANT_ORDER = [
    'कोकण प्रांत',
    'पश्चिम प्रांत',
    'देवगिरी प्रांत',
    'विदर्भ प्रांत'
  ];

  const uniquePrants = (
    this.uniqueData(
      this.offrepwiseData,
      (a: any) => a.prant_name
    ) as any[]
  ).sort((a: any, b: any) => {

    const indexA = PRANT_ORDER.indexOf(
      (a.prant_name || '').trim()
    );

    const indexB = PRANT_ORDER.indexOf(
      (b.prant_name || '').trim()
    );

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;

    return (a.prant_name || '').localeCompare(
      b.prant_name || ''
    );
  });

  for (const prant of uniquePrants) {

    const prantData = this.offrepwiseData.filter(
      (a: any) => a.prant_name === prant.prant_name
    );

    const repDataGroup: any[] = [];

    const uniqueDistricts = this.uniqueData(
      prantData,
      (a: any) => a.rep_district
    ) as any[];

    for (const dist of uniqueDistricts) {

      const districtData = prantData.filter(
        (a: any) => a.rep_district === dist.rep_district
      );

      const uniqueReps = this.uniqueData(
        districtData,
        (a: any) => a.rep_name
      ) as any[];

      for (const rep of uniqueReps) {

        const repRecords = districtData.filter(
          (a: any) => a.rep_name === rep.rep_name
        );

        const repKey = normalize(rep.rep_name);

        const donation = donationMap[repKey] || {
          count: 0,
          amount: 0
        };

        const pendingAmt = pendingMap[repKey] || 0;

        if (!repRecords.length) continue;

        const subTotal: any = {

          ...repRecords[0],

          sub: 0,

          'एकूण': 0,
          'नवीन': 0,
          'नूतनीकरण': 0,
          'नूतनीकरणबाकी': 0,

          net_नवीन: 0,
          net_नूतनीकरण: 0,
          net_नूतनीकरणबाकी: 0,
          net_एकूण: 0,
          net_amount: 0,

          yojana_नवीन: 0,
          yojana_नूतनीकरण: 0,
          yojana_नूतनीकरणबाकी: 0,
          yojana_एकूण: 0,
          yojana_amount: 0,

          ठेवीदार: 0,

          'देणगी': 0,
          'देणगी_amount': 0,

          pending_amount: 0
        };

        this.subTypesName.forEach((b: any) => {

          if (!b.isVisible) return;

          const key = this.getKey(b.name);

          subTotal[key + '_नवीन'] = 0;
          subTotal[key + '_नूतनीकरण'] = 0;
          subTotal[key + '_नूतनीकरणबाकी'] = 0;
          subTotal[key + '_एकूण'] = 0;
        });

        const today = new Date();

        today.setMonth(today.getMonth() + 1);

        for (const record of repRecords) {

          if (record.isPendingOnlyRecord) {
            continue;
          }

          const subType = record.subscription_type || '';

          const key = this.getKey(subType);

          const isFuture =
            new Date(record.sub_perid_to_date) > today;

          const amt = Number(record.total_amt) || 0;

          if (subType !== DEPOSIT_TYPE) {

            subTotal.sub++;
            finalTotal.sub++;
          }

          if (subType === DEPOSIT_TYPE && key) {

            subTotal['ठेवीदार']++;
            finalTotal['ठेवीदार']++;

            if (record.rcpt_type === 'New') {

              subTotal[key + '_नवीन']++;
              finalTotal[key + '_नवीन']++;

            } else {

              subTotal[key + '_नूतनीकरण']++;
              finalTotal[key + '_नूतनीकरण']++;
            }

            subTotal[key + '_एकूण'] =
              (subTotal[key + '_एकूण'] || 0) + amt;

            finalTotal[key + '_एकूण'] =
              (finalTotal[key + '_एकूण'] || 0) + amt;
          }

          if (NET_TYPES.includes(subType)) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal.net_नवीन++;
                finalTotal.net_नवीन++;

              } else {

                subTotal.net_नूतनीकरण++;
                finalTotal.net_नूतनीकरण++;
              }

            } else {

              subTotal.net_नूतनीकरणबाकी++;
              finalTotal.net_नूतनीकरणबाकी++;
            }

            subTotal.net_amount =
              (subTotal.net_amount || 0) + amt;

            finalTotal.net_amount =
              (finalTotal.net_amount || 0) + amt;

            subTotal.net_एकूण++;
            finalTotal.net_एकूण++;
          }

          if (!EXCLUDE_YOJANA.includes(subType)) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal.yojana_नवीन++;
                finalTotal.yojana_नवीन++;

              } else {

                subTotal.yojana_नूतनीकरण++;
                finalTotal.yojana_नूतनीकरण++;
              }

            } else {

              subTotal.yojana_नूतनीकरणबाकी++;
              finalTotal.yojana_नूतनीकरणबाकी++;
            }

            subTotal.yojana_amount =
              (subTotal.yojana_amount || 0) + amt;

            finalTotal.yojana_amount =
              (finalTotal.yojana_amount || 0) + amt;

            subTotal.yojana_एकूण++;
            finalTotal.yojana_एकूण++;
          }

          if (key && subType !== DEPOSIT_TYPE) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal[key + '_नवीन']++;
                finalTotal[key + '_नवीन']++;

              } else {

                subTotal[key + '_नूतनीकरण']++;
                finalTotal[key + '_नूतनीकरण']++;
              }

            } else {

              subTotal[key + '_नूतनीकरणबाकी']++;
              finalTotal[key + '_नूतनीकरणबाकी']++;
            }

            subTotal[key + '_एकूण'] =
              (subTotal[key + '_एकूण'] || 0) + amt;

            finalTotal[key + '_एकूण'] =
              (finalTotal[key + '_एकूण'] || 0) + amt;
          }

          if (subType !== DEPOSIT_TYPE) {

            if (isFuture) {

              if (record.rcpt_type === 'New') {

                subTotal['नवीन']++;
                finalTotal['नवीन']++;

              } else {

                subTotal['नूतनीकरण']++;
                finalTotal['नूतनीकरण']++;
              }

            } else {

              subTotal['नूतनीकरणबाकी']++;
              finalTotal['नूतनीकरणबाकी']++;
            }

            subTotal['एकूण'] =
              (subTotal['एकूण'] || 0) + amt;

            finalTotal['एकूण'] =
              (finalTotal['एकूण'] || 0) + amt;
          }
        }

        subTotal['देणगी'] = donation.count;

        subTotal['देणगी_amount'] = donation.amount;

        finalTotal['देणगी'] += donation.count;

        finalTotal['देणगी_amount'] += donation.amount;

        subTotal['pending_amount'] = pendingAmt;

        finalTotal['pending_amount'] += pendingAmt;

        subTotal['row_total'] =
          (subTotal['एकूण'] || 0) +
          (subTotal['net_amount'] || 0) +
          (subTotal['yojana_amount'] || 0) +
          (subTotal['देणगी_amount'] || 0) +
          (subTotal['pending_amount'] || 0);

        repDataGroup.push(subTotal);
      }
    }

    const prantTotal = repDataGroup.reduce((acc: any, row: any) => {

      Object.keys(row).forEach(k => {

        if (typeof row[k] === 'number') {

          acc[k] = (acc[k] || 0) + row[k];
        }
      });

      return acc;

    }, {
      name: prant.prant_name + ' - एकूण',
      isOfficeRepTotal: true
    });

    repDataGroup.push(prantTotal);

    this.finalData.push(repDataGroup);
  }

  finalTotal['row_total'] =
    (finalTotal['एकूण'] || 0) +
    (finalTotal['net_amount'] || 0) +
    (finalTotal['yojana_amount'] || 0) +
    (finalTotal['देणगी_amount'] || 0) +
    (finalTotal['pending_amount'] || 0);

  this.finalData.push(finalTotal);

  this.isLoading = false;
}
   
   createEmptyTotal(ref: any): any {
     const total: any = {
       name: 'एकूण',
       district_name: ref.district_name,
       office_rep_name: ref.office_rep_name,
       sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
     };
   
     this.subTypesName.forEach(sub => {
       if (sub.isVisible) {
         const key = this.getKey(sub.name);
         total[key + '_नवीन'] = 0;
         total[key + '_नूतनीकरण'] = 0;
         total[key + '_एकूण'] = 0;
         total[key + '_नूतनीकरणबाकी'] = 0;
       }
     });
   
     return total;
   }
   
   addToTotal(total: any, record: any): void {
     total.sub += record.sub || 0;
     total['एकूण'] += record['एकूण'] || 0;
     total['नवीन'] += record['नवीन'] || 0;
     total['नूतनीकरण'] += record['नूतनीकरण'] || 0;
     total['नूतनीकरणबाकी'] += record['नूतनीकरणबाकी'] || 0;
   
     this.subTypesName.forEach(sub => {
       if (sub.isVisible) {
         const key = this.getKey(sub.name);
         total[key + '_नवीन'] += record[key + '_नवीन'] || 0;
         total[key + '_नूतनीकरण'] += record[key + '_नूतनीकरण'] || 0;
         total[key + '_एकूण'] += record[key + '_एकूण'] || 0;
         total[key + '_नूतनीकरणबाकी'] += record[key + '_नूतनीकरणबाकी'] || 0;
       }
     });
   }
   
   
     getKey(name) {
       return name.replaceAll(' ', '_');
     }
   
     uniqueData(data, key) {
       return [...new Map(data.map((a) => [key(a), a])).values()];
     }
   
     exportExcel(fileName) {
       /* table id is passed over here */
       let element = document.getElementById('print-section');
       const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
   
       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
   
       /* save to file */
       XLSX.writeFile(wb, fileName + '.xlsx');
     }
   
   
     //Main Report Method Use in all Printing Page
     show = false
printPage() {
  this.show = true;

  const printContent = document.getElementById('print-section')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { 
                size: A3 landscape;
                margin: 5mm;
              }

              body { 
                font-family: Arial, sans-serif; 
                font-size: 13px;
                margin: 0; 
                padding: 5mm; 
                line-height: 1.2; 
              }

              table { 
                width: 100%; 
                border-collapse: collapse; 
                table-layout: auto; /* ✅ FIX: allow flexible width */
              }

              th, td { 
                padding: 3px; 
                border: 1px solid black; 
                text-align: center; 
                font-size: 11px;
                line-height: 1.2;
                white-space: nowrap; /* ✅ prevent breaking */
              }

              th {
                font-weight: bold;
                white-space: normal; /* ✅ allow header wrap properly */
                word-break: break-word; /* ✅ clean wrap */
              }

              tr {
                page-break-inside: avoid; /* ✅ avoid row breaking */
              }

              thead {
                display: table-header-group; /* ✅ repeat header on next page */
              }

              tfoot {
                display: table-footer-group;
              }

              .largeHeading {
                font-size: 14px !important;
                white-space: normal !important; /* ✅ fix long heading */
                word-break: break-word;
              }

              .smallHeading {
                font-size: 12px !important;
                font-weight: bold;
              }

              .noPrint { 
                display: none;
              }
            }
          </style>
        </head>

        <body>
          <div id="print-section">
            ${printContent}
          </div>

          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

}
